import { render, staticRenderFns } from "./Countup.vue?vue&type=template&id=5c2cbc86&scoped=true&"
import script from "./Countup.vue?vue&type=script&lang=js&"
export * from "./Countup.vue?vue&type=script&lang=js&"
import style0 from "./Countup.vue?vue&type=style&index=0&id=5c2cbc86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2cbc86",
  null
  
)

export default component.exports